<script context="module">
  import { External as Ext, M as MS } from '../../external';
  import ButtonStyling from './ButtonStyling.svelte';

  export const changeButtonStyling = async (styles) => {
    return new Promise(resolve => {
      let changedStyle = null;
      Ext.Tools.showWindow({
        title: M.BUTTON_STYLE,
        icon: Ext.Popup.ICON_EDIT,
        width: 650,
        addCloseButton: true,
        isModal: true,
        withDarkBackground: true,
        forceAtRight: Ext.showBuilderPopupsOnFullHeight,
        action: {
          onShow: (popup, context) => {
            popup.bindComponent(new ButtonStyling({
              target: popup.getContentArea(),
              props: {
                styles: styles,
                onChange: (style) => changedStyle = style
              }
            }));
          },
          onHide: () => resolve(changedStyle ? changedStyle : null)
        }
      });
    });
  };
</script>
<script>
  import ColorPicker from '../../Common/ColorPicker.svelte';
  import { onMount } from 'svelte';
  import { External, M } from '../../external';
  import Slider from '../../Common/Slider.svelte';
  import { ignore } from '../../Common/tools';

  export let style = {}, onChange = ignore;

  const defaults = {
    color: '',
    colorClass: 'secondary',
    textColor: '',
    textColorClass: 'primary',
    text: M.BUY,
    fontSize: 14,
    fontFamily: 'Open Sans'
  };

  const fonts = External.GlobalStyling.getAvailableFontNames() || [];

  const triggerChange = () => onChange(style);

  onMount(() => {
    style = { ...defaults, ...style };
  });

</script>
<div class="popup-widget-wrapper">
  <div class="input-wrapper color-pick-wrap-widgets">
    <ColorPicker bind:color={style.color} bind:colorClass={style.colorClass} onChange={triggerChange} label="{M.BUTTON_BACKGROUND_COLOR}" />
  </div>
  <div class="input-wrapper color-pick-wrap-widgets">
    <ColorPicker bind:color={style.textColor} bind:colorClass={style.textColorClass} onChange={triggerChange} label="{M.BUTTON_TEXT_COLOR}" />
  </div>

  <div class="popup-input-wrapper mt-15">
    <div class="info">
      <h5>{M.FONT}</h5>
    </div>
    <select bind:value={style.fontFamily} on:change={triggerChange}>
      {#each fonts as font}
        <option value={font}>{font}</option>
      {/each}
    </select>
  </div>

  <div class="popup-input-wrapper input-slider-wrapper">
    <Slider bind:value={style.fontSize} min={1} max={100} label={M.FONT_SIZE} onChange={triggerChange} />
  </div>

  <div class="popup-input-wrapper">
    <div class="info">
      <h5>{M.BUTTON_TEXT}</h5>
      <input type="text" bind:value={style.text} class="transition-all" on:change={triggerChange}>
    </div>
  </div>
</div>
